import api from './api';

const VERSION_API_BASE = '/admin/version';

export const versionService = {
  // Get all versions with pagination and filters
  getVersions: async (params = {}) => {
    try {
      const response = await api.get(`${VERSION_API_BASE}/versions/`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching versions:', error);
      throw error;
    }
  },

  // Get single version by ID
  getVersion: async (id) => {
    try {
      const response = await api.get(`${VERSION_API_BASE}/versions/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching version:', error);
      throw error;
    }
  },

  // Create new version
  createVersion: async (versionData) => {
    try {
      const response = await api.post(`${VERSION_API_BASE}/versions/`, versionData);
      return response.data;
    } catch (error) {
      console.error('Error creating version:', error);
      throw error;
    }
  },

  // Update version
  updateVersion: async (id, versionData) => {
    try {
      const response = await api.put(`${VERSION_API_BASE}/versions/${id}/`, versionData);
      return response.data;
    } catch (error) {
      console.error('Error updating version:', error);
      throw error;
    }
  },

  // Partial update version
  patchVersion: async (id, versionData) => {
    try {
      const response = await api.patch(`${VERSION_API_BASE}/versions/${id}/`, versionData);
      return response.data;
    } catch (error) {
      console.error('Error patching version:', error);
      throw error;
    }
  },

  // Delete version
  deleteVersion: async (id) => {
    try {
      const response = await api.delete(`${VERSION_API_BASE}/versions/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error deleting version:', error);
      throw error;
    }
  },

  // Check for updates (for mobile app)
  checkForUpdates: async (version, platform) => {
    try {
      const response = await api.get('/app/version/check/', {
        params: { version, platform }
      });
      return response.data;
    } catch (error) {
      console.error('Error checking for updates:', error);
      throw error;
    }
  }
};

export default versionService;

